import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { StyledSlot } from "scmp-app/components/advertisement/ad-slots/ad-slot/styles";
import { Figure } from "scmp-app/components/content/content-cover-image/styles";
import {
  Container as NativeArticleContainer,
  SponsorBox as NativeArticleSponsorBox,
} from "scmp-app/components/content/content-item-render/variants/home-native-article/styles";
import {
  Container as SecondaryContainer,
  CoverImage as SecondaryCoverImage,
  Headline as SecondaryHeadline,
  Summary as SecondarySummary,
} from "scmp-app/components/content/content-item-render/variants/home-secondary-v2/styles";
import { HomeV2TopStoriesItem } from "scmp-app/components/home-v2/top-stories-item";

export const AdSlotContainer = styled.div`
  ${StyledSlot} {
    align-items: flex-start;
  }
`;

export const StyledTopStoriesItem = styled(HomeV2TopStoriesItem)`
  ${SecondaryContainer} {
    ${theme.breakpoints.only("tablet")} {
      grid-template-columns: 0.4fr 0.6fr;
    }
  }
`;

export const HorizontalDivider = styled.div`
  inline-size: 100%;
  block-size: 0;
  border-block-start: 1px #dfdfdf solid;

  ${theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const VerticalDivider = styled.div`
  inline-size: 0;
  block-size: 100%;
  border-inline-start: 1px #dfdfdf solid;

  ${theme.breakpoints.down("tablet")} {
    display: none;
  }
`;

export const InlineAds = styled.div`
  grid-area: inline-ads;

  padding-block: 12px;

  ${theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const PlusWidget = styled.div`
  grid-area: plus-widget;

  :empty {
    margin: 0;
    padding: 0;

    border: none;
  }
`;

export const TopStory1 = styled.div`
  grid-area: top-story-1;
`;

export const TopStory2 = styled.div`
  grid-area: top-story-2;
`;

export const TopStory3 = styled.div`
  grid-area: top-story-3;
`;

export const TopStory4 = styled.div`
  grid-area: top-story-4;

  display: flex;
  flex-flow: column nowrap;
  gap: 16px;

  ${NativeArticleSponsorBox} {
    gap: 2px;
  }

  ${theme.breakpoints.only("mobile")} {
    ${SecondarySummary} {
      display: none;
    }

    ${SecondaryHeadline} {
      font-weight: 600;
      font-size: 16px;
      font-style: normal;
      line-height: 130%;
      letter-spacing: -0.32px;
    }

    ${SecondaryContainer} {
      grid:
        "header cover-image" min-content
        "headline cover-image" min-content
        "subHeadline cover-image" min-content
        "summary cover-image" min-content
        "action-bar cover-image" min-content
        ". cover-image" minmax(0, 1fr)
        / minmax(0, 1fr) 144px;
      column-gap: 16px;
    }

    ${SecondaryHeadline} {
      font-weight: 600;
      font-size: 16px;
      line-height: 120%;
      letter-spacing: -0.32px;
    }

    ${SecondaryCoverImage} {
      margin-block-start: 0;
    }
  }

  ${theme.breakpoints.up("tablet")} {
    flex-flow: row nowrap;
    gap: 20px;
    align-items: flex-start;

    ${StyledTopStoriesItem} {
      flex: 1 1 auto;
    }

    ${SecondaryContainer} {
      grid-template-columns: minmax(250px, auto) minmax(200px, 280px);
    }

    ${SecondaryCoverImage} {
      max-inline-size: 280px;

      ${Figure} picture {
        aspect-ratio: 3 / 2;
      }
    }

    ${NativeArticleContainer} {
      min-inline-size: 140px;
      max-inline-size: 200px;
    }
  }
`;

export const TopStory5 = styled.div`
  grid-area: top-story-5;
`;

export const TopStory6 = styled.div`
  grid-area: top-story-6;
`;

export const TopStory7 = styled.div`
  grid-area: top-story-7;
`;

export const TopStory8 = styled.div`
  grid-area: top-story-8;

  ${SecondarySummary} {
    display: none;
  }

  ${SecondaryHeadline} {
    font-weight: 600;
    font-size: 16px;
    line-height: 130%;
    letter-spacing: -0.32px;
  }

  ${SecondaryCoverImage} {
    max-inline-size: 144px;

    ${theme.breakpoints.only("mobile")} {
      margin-block-start: 0;
    }
  }

  ${SecondaryContainer} {
    grid:
      "header cover-image" min-content
      "headline cover-image" min-content
      "subHeadline cover-image" min-content
      "summary cover-image" min-content
      "action-bar cover-image" min-content
      ". cover-image" minmax(0, 1fr)
      / minmax(0, 1fr) 144px;
    column-gap: 16px;
  }

  ${theme.breakpoints.up("tablet")} {
    display: flex;
    flex-direction: row;
    gap: 20px;

    margin-inline-end: -20px;

    ${SecondaryCoverImage} {
      max-inline-size: 144px;
    }
  }
`;

export const TopStory9 = styled.div`
  grid-area: top-story-9;

  ${SecondarySummary} {
    display: none;
  }

  ${SecondaryHeadline} {
    font-weight: 600;
    font-size: 16px;
    line-height: 130%;
    letter-spacing: -0.32px;
  }

  ${SecondaryCoverImage} {
    max-inline-size: 144px;

    ${theme.breakpoints.only("mobile")} {
      margin-block-start: 0;
    }
  }

  ${SecondaryContainer} {
    grid:
      "header cover-image" min-content
      "headline cover-image" min-content
      "subHeadline cover-image" min-content
      "summary cover-image" min-content
      "action-bar cover-image" min-content
      ". cover-image" minmax(0, 1fr)
      / minmax(0, 1fr) 144px;
    column-gap: 16px;
  }

  ${theme.breakpoints.up("tablet")} {
    padding-inline-start: 20px;

    ${SecondaryCoverImage} {
      max-inline-size: 144px;
    }
  }
`;

export const TopStory10 = styled.div`
  grid-area: top-story-10;
`;

export const TopStory11 = styled.div`
  grid-area: top-story-11;

  ${theme.breakpoints.only("mobile")} {
    ${SecondarySummary} {
      display: none;
    }

    ${SecondaryHeadline} {
      font-weight: 600;
      font-size: 16px;
      line-height: 130%;
      letter-spacing: -0.32px;
    }

    ${SecondaryContainer} {
      grid:
        "header cover-image" min-content
        "headline cover-image" min-content
        "subHeadline cover-image" min-content
        "summary cover-image" min-content
        "action-bar cover-image" min-content
        ". cover-image" minmax(0, 1fr)
        / minmax(0, 1fr) 144px;
      column-gap: 16px;
    }

    ${SecondaryHeadline} {
      font-weight: 600;
      font-size: 16px;
      line-height: 120%;
      letter-spacing: -0.32px;
    }

    ${SecondaryCoverImage} {
      margin-block-start: 0;
    }
  }
`;

export const TopStory12 = styled.div`
  grid-area: top-story-12;

  ${theme.breakpoints.only("mobile")} {
    ${SecondarySummary} {
      display: none;
    }

    ${SecondaryHeadline} {
      font-weight: 600;
      font-size: 16px;
      line-height: 130%;
      letter-spacing: -0.32px;
    }

    ${SecondaryContainer} {
      grid:
        "header cover-image" min-content
        "headline cover-image" min-content
        "subHeadline cover-image" min-content
        "summary cover-image" min-content
        "action-bar cover-image" min-content
        ". cover-image" minmax(0, 1fr)
        / minmax(0, 1fr) 144px;
      column-gap: 16px;
    }

    ${SecondaryHeadline} {
      font-weight: 600;
      font-size: 16px;
      line-height: 120%;
      letter-spacing: -0.32px;
    }

    ${SecondaryCoverImage} {
      margin-block-start: 0;
    }
  }
`;

export const TopStory13 = styled.div`
  grid-area: top-story-13;
`;

export const TopStory14 = styled.div`
  grid-area: top-story-14;

  ${theme.breakpoints.only("mobile")} {
    ${SecondarySummary} {
      display: none;
    }

    ${SecondaryHeadline} {
      font-weight: 600;
      font-size: 16px;
      font-style: normal;
      line-height: 130%;
      letter-spacing: -0.32px;
    }

    ${SecondaryContainer} {
      grid:
        "header cover-image" min-content
        "headline cover-image" min-content
        "subHeadline cover-image" min-content
        "summary cover-image" min-content
        "action-bar cover-image" min-content
        ". cover-image" minmax(0, 1fr)
        / minmax(0, 1fr) 144px;
      column-gap: 16px;
    }

    ${SecondaryHeadline} {
      font-weight: 600;
      font-size: 16px;
      line-height: 120%;
      letter-spacing: -0.32px;
    }

    ${SecondaryCoverImage} {
      margin-block-start: 0;
    }
  }
`;

export const TopStory15 = styled.div`
  grid-area: top-story-15;

  display: flex;
  flex-flow: column nowrap;
  gap: 16px;

  ${theme.breakpoints.only("mobile")} {
    ${SecondarySummary} {
      display: none;
    }

    ${SecondaryHeadline} {
      font-weight: 600;
      font-size: 16px;
      font-style: normal;
      line-height: 130%;
      letter-spacing: -0.32px;
    }

    ${SecondaryContainer} {
      grid:
        "header cover-image" min-content
        "headline cover-image" min-content
        "subHeadline cover-image" min-content
        "summary cover-image" min-content
        "action-bar cover-image" min-content
        ". cover-image" minmax(0, 1fr)
        / minmax(0, 1fr) 144px;
      column-gap: 16px;
    }

    ${SecondaryHeadline} {
      font-weight: 600;
      font-size: 16px;
      line-height: 120%;
      letter-spacing: -0.32px;
    }

    ${SecondaryCoverImage} {
      margin-block-start: 0;
    }
  }

  ${theme.breakpoints.up("tablet")} {
    flex-flow: row nowrap;
    gap: 20px;
    align-items: flex-start;

    ${StyledTopStoriesItem} {
      flex: 1 1 auto;
    }

    ${SecondaryContainer} {
      grid-template-columns: minmax(200px, auto) minmax(200px, 280px);
    }

    ${SecondaryCoverImage} {
      max-inline-size: 280px;

      ${Figure} picture {
        aspect-ratio: 3 / 2;
      }
    }

    ${AdSlotContainer} {
      min-inline-size: 200px;
      max-inline-size: 200px;
    }
  }
`;

type ContainerProps = {
  $hasScmpPlusAccessRight?: boolean;
};

export const Container = styled.div<ContainerProps>`
  display: grid;
  ${props =>
    props.$hasScmpPlusAccessRight
      ? css`
          grid:
            "top-story-1" min-content
            "inline-ads" min-content
            "top-story-2" min-content
            "top-story-3" min-content
            "top-story-4" min-content
            "top-story-5" min-content
            "top-story-6" min-content
            "top-story-7" min-content
            "top-story-8" min-content
            "top-story-9" min-content
            "top-story-10" min-content
            "top-story-11" min-content
            "top-story-12" min-content
            "plus-widget" min-content
            "top-story-13" min-content
            "top-story-14" min-content
            "top-story-15" min-content
            / 100%;
          gap: 20px 0;

          ${theme.breakpoints.up("tablet")} {
            grid:
              "top-story-1 top-story-1" min-content
              "top-story-2 top-story-2" min-content
              "top-story-3 top-story-3" min-content
              "top-story-4 top-story-4" min-content
              "top-story-5 top-story-5" min-content
              "top-story-6 top-story-6" min-content
              "top-story-7 top-story-7" min-content
              "top-story-8 top-story-9" min-content
              "top-story-10 top-story-10" min-content
              "top-story-11 top-story-11" min-content
              "top-story-12 top-story-12" min-content
              "plus-widget plus-widget" min-content
              "top-story-13 top-story-13" min-content
              "top-story-14 top-story-14" min-content
              "top-story-15 top-story-15" min-content
              / 0.5fr 0.5fr;
            gap: 24px 20px;
          }

          ${theme.breakpoints.up("desktop")} {
            gap: 32px 20px;
          }
        `
      : css`
          grid:
            "top-story-1" min-content
            "inline-ads" min-content
            "top-story-2" min-content
            "top-story-3" min-content
            "top-story-4" min-content
            "top-story-5" min-content
            "top-story-6" min-content
            "top-story-7" min-content
            "top-story-8" min-content
            "top-story-9" min-content
            "top-story-10" min-content
            "top-story-11" min-content
            "top-story-12" min-content
            "top-story-13" min-content
            "top-story-14" min-content
            "top-story-15" min-content
            / 100%;
          gap: 20px 0;

          ${theme.breakpoints.up("tablet")} {
            grid:
              "top-story-1 top-story-1" min-content
              "top-story-2 top-story-2" min-content
              "top-story-3 top-story-3" min-content
              "top-story-4 top-story-4" min-content
              "top-story-5 top-story-5" min-content
              "top-story-6 top-story-6" min-content
              "top-story-7 top-story-7" min-content
              "top-story-8 top-story-9" min-content
              "top-story-10 top-story-10" min-content
              "top-story-11 top-story-11" min-content
              "top-story-12 top-story-12" min-content
              "top-story-13 top-story-13" min-content
              "top-story-14 top-story-14" min-content
              "top-story-15 top-story-15" min-content
              / 0.5fr 0.5fr;
            gap: 24px 20px;
          }

          ${theme.breakpoints.up("desktop")} {
            gap: 32px 20px;
          }
        `}

  > *:not(${InlineAds}) {
    border-block-start: 1px #000000 solid;

    padding-block-start: 12px;

    ${theme.breakpoints.up("tablet")} {
      padding-block-start: 24px;
    }
  }

  ${PlusWidget} {
    padding-block-start: 12px;
  }
`;
